module.exports = __webpack_public_path__ + "static/media/spotify.f423d85d.png";